module.exports = __webpack_public_path__ + "static/media/icone-config.57a4a2a3.svg";